import { Text } from 'foundations-components/components/Text';
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaSearchTitleWrapper = ({
  isDisabled = false,
  title,
  resultCount
}) => {
  return /*#__PURE__*/_jsxs(Text, {
    as: "div",
    use: isDisabled ? 'disabled' : 'default',
    children: [title, ` (${resultCount})`]
  });
};
export default PatagoniaSearchTitleWrapper;